import React from "react";
import classnames from "classnames";
import SkeletonDiv from "common/Components/SkeletonDiv";
import { emailStatsVariant } from "./EmailDripItem.constants";

function MobileStatsLoader({ statsVariant }) {
  const isOpaque =
    statsVariant === emailStatsVariant.WITH_WITH_OVERLAY ||
    statsVariant === emailStatsVariant.GREYED_OUT;
  return (
    <div
      className={classnames(
        "tw-grid tw-grid-cols-2 tw-gap-2 tw-p-3 tw-border-t tw-border-b-0 tw-border-r-0 tw-border-l-0 tw-border-solid tw-border-[#e7e6e4] max-[375px]:tw-gap-1 max-[375px]:tw-p-1",
        isOpaque && "tw-opacity-50"
      )}
    >
      <div className="tw-flex tw-gap-3 tw-font-normal tw-text-[10px] tw-leading-[12px] tw-tracking-[0.04em] tw-rounded-[10px] tw-text-[rgba(0,0,0,0.4)] tw-bg-[#fbfbfb] tw-py-[10px] tw-pl-[10px] tw-pr-[3px]">
        <SkeletonDiv
          background="#EDEDED"
          width="38px"
          height="38px"
          borderRadius="10px"
        />
        <div>
          <SkeletonDiv
            background="#EDEDED"
            width="44px"
            height="8px"
            borderRadius="13px"
          />
          <SkeletonDiv
            width="49px"
            height="14px"
            borderRadius="13px"
            marginTop="11px"
          />
        </div>
      </div>
      <div className="tw-flex tw-gap-3 tw-font-normal tw-text-[10px] tw-leading-[12px] tw-tracking-[0.04em] tw-rounded-[10px] tw-text-[rgba(0,0,0,0.4)] tw-bg-[#fbfbfb] tw-py-[10px] tw-pl-[10px] tw-pr-[3px]">
        <SkeletonDiv
          background="#EDEDED"
          width="38px"
          height="38px"
          borderRadius="10px"
        />

        <div>
          <SkeletonDiv
            background="#EDEDED"
            width="44px"
            height="8px"
            borderRadius="13px"
          />
          <SkeletonDiv
            width="49px"
            height="14px"
            borderRadius="13px"
            marginTop="11px"
          />
        </div>
      </div>
      <div className="tw-flex tw-gap-3 tw-font-normal tw-text-[10px] tw-leading-[12px] tw-tracking-[0.04em] tw-rounded-[10px] tw-text-[rgba(0,0,0,0.4)] tw-bg-[#fbfbfb] tw-py-[10px] tw-pl-[10px] tw-pr-[3px]">
        <SkeletonDiv
          background="#EDEDED"
          width="38px"
          height="38px"
          borderRadius="10px"
        />

        <div>
          <SkeletonDiv
            background="#EDEDED"
            width="44px"
            height="8px"
            borderRadius="13px"
          />
          <SkeletonDiv
            width="49px"
            height="14px"
            borderRadius="13px"
            marginTop="11px"
          />
        </div>
      </div>
      <div className="tw-flex tw-gap-3 tw-font-normal tw-text-[10px] tw-leading-[12px] tw-tracking-[0.04em] tw-rounded-[10px] tw-text-[rgba(0,0,0,0.4)] tw-bg-[#fbfbfb] tw-py-[10px] tw-pl-[10px] tw-pr-[3px]">
        <SkeletonDiv
          background="#EDEDED"
          width="38px"
          height="38px"
          borderRadius="10px"
        />

        <div>
          <SkeletonDiv
            background="#EDEDED"
            width="44px"
            height="8px"
            borderRadius="13px"
          />
          <SkeletonDiv
            width="49px"
            height="14px"
            borderRadius="13px"
            marginTop="11px"
          />
        </div>
      </div>
    </div>
  );
}

function MobileDripItemLoader({ showExtraRow, showStats, statsVariant }) {
  return (
    <section className="tw-bg-white tw-border-[1.5px] tw-border-solid tw-border-[#dfdfdf] tw-rounded-[5px] tw-mb-5">
      <div className="tw-py-[10px] tw-px-2 tw-flex tw-items-center tw-gap-2 tw-w-[calc(100vw-32px)]">
        <SkeletonDiv
          background="#EBEBEB"
          width="24px"
          height="24px"
          borderRadius="50%"
        />
        <div className="flex_grow">
          <SkeletonDiv width="190px" height="14px" />
        </div>
        <SkeletonDiv width="26px" height="14px" background="#D9D9D9" />
      </div>
      <div className="tw-px-3">
        <div className="tw-border-t tw-border-b-0 tw-border-r-0 tw-border-l-0 tw-border-solid tw-border-[#e7e6e4] tw-font-normal tw-text-[14px] tw-leading-[18px] tw-tracking-[0.02em] tw-text-black tw-py-[10px] tw-flex tw-justify-between tw-items-start">
          <SkeletonDiv width="104px" height="14px" />
          <SkeletonDiv width="172px" height="9px" background="#ECECEC" />
        </div>
        <div className="tw-border-t tw-border-b-0 tw-border-r-0 tw-border-l-0 tw-border-solid tw-border-[#e7e6e4] tw-font-normal tw-text-[14px] tw-leading-[18px] tw-tracking-[0.02em] tw-text-black tw-py-[10px] tw-flex tw-justify-between tw-items-start">
          <SkeletonDiv width="104px" height="14px" />
          <SkeletonDiv width="90px" height="9px" background="#ECECEC" />
        </div>

        <div className="tw-border-t tw-border-b-0 tw-border-r-0 tw-border-l-0 tw-border-solid tw-border-[#e7e6e4] tw-font-normal tw-text-[14px] tw-leading-[18px] tw-tracking-[0.02em] tw-text-black tw-py-[10px] tw-flex tw-justify-between tw-items-start">
          <SkeletonDiv width="104px" height="14px" />
          <SkeletonDiv width="24px" height="9px" background="#ECECEC" />
        </div>
        {showExtraRow && (
          <div className="tw-border-t tw-border-b-0 tw-border-r-0 tw-border-l-0 tw-border-solid tw-border-[#e7e6e4] tw-font-normal tw-text-[14px] tw-leading-[18px] tw-tracking-[0.02em] tw-text-black tw-py-[10px] tw-flex tw-justify-between tw-items-start">
            <SkeletonDiv width="104px" height="14px" />
            <SkeletonDiv width="33px" height="9px" background="#ECECEC" />
          </div>
        )}
      </div>
      {showStats && <MobileStatsLoader statsVariant={statsVariant} />}
    </section>
  );
}

export default MobileDripItemLoader;
